import { useEffect, useRef, useState } from "react";
import "./Typewriter.css";

export default function Typewriter({
  texts = ["Hello World!"],
  typingSpeed = 100,
  deletingSpeed = 50,
  pause = 1500,
  loop = true,
}) {
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [blink, setBlink] = useState(true);
  const [text, setText] = useState("");
  const [isFading, setIsFading] = useState(false);

  const typingTimeout = useRef(null);
  const blinkInterval = useRef(null);

  // Cursor blink
  useEffect(() => {
    blinkInterval.current = setInterval(() => {
      setBlink((prev) => !prev);
    }, 500);

    return () => clearInterval(blinkInterval.current);
  }, []);

  // Typing logic
  useEffect(() => {
    const currentText = texts[index];

    // Finished typing → start deleting
    if (!isDeleting && subIndex === currentText.length + 1) {
      setIsFading(true);

      typingTimeout.current = setTimeout(() => {
        setIsFading(false);
        setIsDeleting(true);
      }, 400);

      return;
    }

    // Finished deleting → move to next text
    if (isDeleting && subIndex === 0) {
      const nextIndex = index + 1;
      if (!loop && nextIndex >= texts.length) return;

      setIsFading(true);

      typingTimeout.current = setTimeout(() => {
        setIsDeleting(false);
        setIndex(nextIndex % texts.length);
        setIsFading(false);
      }, 400);

      return;
    }

    typingTimeout.current = setTimeout(
      () => {
        setSubIndex((prev) => prev + (isDeleting ? -1 : 1));
        setText(currentText.substring(0, subIndex));
      },
      isDeleting ? deletingSpeed : typingSpeed
    );

    return () => clearTimeout(typingTimeout.current);
  }, [subIndex, index, isDeleting, texts, typingSpeed, deletingSpeed, loop]);

  return (
    <div className={`typewriter ${isFading ? "fade" : ""}`}>
      {text}
      <span className="cursor" style={{ opacity: blink ? 1 : 0 }}>
        _
      </span>
    </div>
  );
}
